import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin, NavbarPlugin } from 'bootstrap-vue'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Plugin } from 'vue-responsive-video-background-player'
import VueWow from 'vue-wow'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {BootstrapVueIcons } from 'bootstrap-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(Plugin);
Vue.use(VueWow);
Vue.use(BootstrapVueIcons);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(NavbarPlugin);

library.add(faUserSecret);
Vue.component('font-awesome-icon', FontAwesomeIcon);

AOS.init();

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  render: h => h(App),
}).$mount('#app')
